module.exports = __webpack_public_path__ + "img/publish-offer.0f433590.svg";